(function () {
  'use strict';
  angular.module('ringbaPortal').controller('HeaderController', HeaderController);

  function HeaderController(
    $scope,
    $state,
    $timeout,
    $location,
    $log,
    $interval,
    $rootScope,
    authService,
    accountsService,
    cacheService,
    featureFlags,
    promiseCacheService,
    groupByService,
    isMobileDevice,
    mediaQueryService,
    statsService,
    sidebarService,
    notificationService,
    toaster,
    whitelabelService,
    supportChatService,
    systemFlagsService,
    v3HandoffService
  ) {
    'ngInject';

    const vm = this;
    let refreshStatsInterval,refreshNotificationsInterval;

    vm.stats = {};
    vm.accountsService = accountsService;
    vm.authentication = authService.authentication;
    vm.isAffiliate = accountsService.isAffiliate;
    vm.isBuyer = accountsService.isBuyer;
    vm.showSupportText = false;
    vm.unreadChatCount = 0;
    vm.isSiteWhiteLabelled = true;
    vm.logoHref = function () { return __BUILD_CONFIG__.routes.demo != null && v3HandoffService.handsOff('demo') ? '#/dashboard/demo' : '#'; };

    vm.$onInit = onInit;
    vm.handleSidebarToggleClick = handleSidebarToggleClick;
    vm.showCallInfo = showCallInfo;
    vm.showLiveCalls = showLiveCalls;
    vm.changeAccount = changeAccount;
    vm.openCrispChat = openCrispChat;
    vm.hideMessagesPopover = hideMessagesPopover;
    vm.showMessageDetail = showMessageDetail;
    vm.hideChangelogPopover = hideChangelogPopover;
    vm.showOrHideAccountSelectDropdown = showOrHideAccountSelectDropdown;
    vm.supportChatService = supportChatService;
    vm.markAllAsRead = markAllAsRead;
    vm.getAccountRole = getAccountRole;
    vm.getAccountsByRole = getAccountsByRole;
    vm.getAccountRoleDisplay = getAccountRoleDisplay;
    vm.toggleRoleSection = toggleRoleSection;

    vm.openMyTickets = openMyTickets;

    function onInit() {
      const isAdmin = accountsService.isAdmin();
      vm.isMobileView = isMobileDevice && mediaQueryService.evaluateMediaQuery('xs');
      vm.enableChangelog = isAdmin && (vm.authentication.isSuper || featureFlags.isOn('changelog'));
      vm.notificationSharedObject = notificationService.sharedNotificationObject;
      if (vm.notificationSharedObject.messages.length === 0) {
        _loadMessages();
      }

      supportChatService.hideSupportChat();
      vm.showSupportText = isAdmin && whitelabelService.checkLocationHostIsBase();

      supportChatService.onMessages((ct) => {
        vm.unreadChatCount = ct;
      });

      _initHeadway();

      _refreshStats();
      _refreshNotifications();
      refreshStatsInterval = $interval(_refreshStats, 30000);
      refreshNotificationsInterval = $interval(_refreshNotifications, 60000);
      _setPopoverWatch();

      _setSiteWhitelabelled();

      _loadAccountRoles();
    }

    function showLiveCalls() {
      return !vm.isBuyer();
    }

    function showCallInfo() {
      return true;
    }

    function openMyTickets() {
      $state.go('sso.zendesk');
    }

    function handleSidebarToggleClick() {
      sidebarService.sidebarMinified = !sidebarService.sidebarMinified;
      $rootScope.$broadcast('sidebarMinified');
    }

    function changeAccount(account) {
      if (vm.accountsService.currentAccountId !== account.id) {
        setDefault(account);
        vm.accountsService.currentAccountId = account.id;
        vm.toggleAccountDropdown = false;
        promiseCacheService.clearAll();
        _refreshAccount();
      }
    }

    function setDefault(account) {
      vm.accountsService.saveDefaultAccount(account);
    }

    async function openSupportChat() {
      supportChatService.showAndOpenSupportChat();
    }

    function openCrispChat() {
      openSupportChat();
    }

    function hideMessagesPopover() {
      vm.isMessagesPopoverOpen = false;
    }

    function hideChangelogPopover() {
      vm.isChangelogPopoverOpen = false;
    }

    function showOrHideAccountSelectDropdown(show) {
      vm.toggleAccountDropdown = show;
    }

    function showMessageDetail(messageId) {
      vm.toasterSelectedMessageId = messageId;
      vm.isMessagesPopoverOpen = true;
    }

    async function markAllAsRead() {
      // get preview total count and unread count aren't reliable values; API doesn't return counts respecting the 12 month expiration of messages in AeroSpike db
      // so we get all unread messages first before calling this function
      await notificationService.getAllUnreadMessages();
      await notificationService.markAllAsRead();
      _updateUnreadMessages();
    }

    function _initHeadway() {
      $timeout(function () {
        if (window.Headway && window.Headway.init && window.HW_config) {
          window.Headway.init(window.HW_config);
        }
      }, 1000);
    }

    function _loadMessages() {
      return notificationService.getMessages();
    }

    function _refreshAccount() {
      if (vm.accountsService.currentAccountId) {
        return vm.accountsService.selectAccount(vm.accountsService.currentAccountId)
          .then(function () {
            return systemFlagsService.whenSettled();
          })
          .then(function () {
            groupByService.clearGroupBysCache();
            _checkAccountStatePermissionsAndRedirect();
          });
      } else if (_checkAccountNotSelected() &&
        ('dashboard.account' !== $state.current.name)) {
        $log.getInstance('headerController').info('Account not selected, redirecting to dashboard');
        _goHome();
      }
    }

    function _refreshStats() {
      if (vm.accountsService.currentAccountId) {
        statsService.getCallLiveAndCompletedStats(vm.accountsService.currentAccountId)
          .then(function (stats) {
            if (stats) {
              if (stats.values && stats.values.length) {
                stats.values.forEach(function (message) {
                  if (message.messageName === 'Completed') {
                    vm.stats.completed_calls = message.sum;
                  }
                });
              }
              if (stats.live) {
                vm.stats.live_calls = stats.live;
              } else {
                vm.stats.live_calls = 0;
              }
            }
          });
      }
    }

    function _refreshNotifications() {
      _updateUnreadMessages();
    }

    function _goHome() {
      if (authService.authentication.isAuth) {
        const callLogStateName = 'dashboard.call-logs';
        $state.go(vm.accountsService.getAccountDefaultPermissionItem() === 'Dashboard' ? 'dashboard.main' : callLogStateName);
      } else {
        $state.go('dashboard.main');
      }
    }


    function _checkAccountStatePermissionsAndRedirect() {
      if ($state.current && $state.current.data && $state.current.data.permission && vm.accountsService.hasAccess($state.current.data.permission.type, $state.current.data.permission.permission)) {
        $state.reload();
      } else {
        _goHome();
      }
      $location.search({});
    }

    function _checkAccountNotSelected() {
      return authService.authentication.isAuth && !vm.accountsService.currentAccountId;
    }

    function _updateUnreadMessages() {
      const previousTotalCount = vm.notificationSharedObject.totalCount;

      notificationService.getPreviews(true).then(function (data) {
        if (data.toasts && data.toasts.length) {
          for (let i = 0; i < data.toasts.length; i++) {
            const toast = data.toasts[i],
              key = _getCacheKey(toast.id),
              toasted = cacheService.get(key);
            if (!toasted) {
              toaster.pop({
                toasterId: 'miscellaneous-toaster',
                type: 'message',
                title: 'New Message',
                body: '/scripts/shared/components/in-app-notifications/toaster-template.html',
                bodyOutputType: 'template',
                showCloseButton: true,
                timeout: 0,
                directiveData: {
                  preview: _.truncate(toast.preview, {
                    length: 127,
                    separator: ' '
                  }),
                  messageId: toast.id,
                  showMessageDetail: vm.showMessageDetail
                }
              });
              cacheService.set(key, true, {
                persistence: true
              });
            }
          }
        }
        if (previousTotalCount < vm.notificationSharedObject.totalCount) {
          notificationService.getMessages(true);
        }
      });
    }

    function _setPopoverWatch() {
      $scope.$watch(function () {
        return vm.isMessagesPopoverOpen;
      }, function (newVal) {
        if (!newVal) {
          vm.toasterSelectedMessageId = undefined;
        }
      });
    }

    function _getCacheKey(toastId) {
      return 'inAppToast_' + toastId;
    }

    function _onScopeDestroy() {
      supportChatService.logoutFromChat();
      $interval.cancel(refreshStatsInterval);
      $interval.cancel(refreshNotificationsInterval);
    }

    function _setSiteWhitelabelled() {
      whitelabelService.checkIfSiteIsWhitelabelled(accountsService.currentAccountId).then(function (isWhitelabelled) {
        vm.isSiteWhiteLabelled = isWhitelabelled;
      }).catch(function () {
        vm.isSiteWhiteLabelled = false;
      });
    }

    function getAccountRole(accountId) {
      return vm.accountRoles ? vm.accountRoles[accountId] : null;
    }

    function _loadAccountRoles() {
      if (vm.accountRoles) return;

      accountsService.getAccountRoles()
        .then(function(response) {
          if (response.data && response.data.accounts) {
            vm.accountRoles = {};

            response.data.accounts.forEach(function(account) {
              vm.accountRoles[account.accountId] = account.roles[0];
            });
          }
        });
    }

    function getAccountRoleDisplay(accountId) {
      const role = getAccountRole(accountId);
      if (!role) return 'No role';

      if (role.toLowerCase() === 'affiliate') return 'Publisher';
      if (role.toLowerCase() === 'affiliate_manager') return 'Publisher Manager';

      return role;
    }

    function getAccountsByRole(roleType) {
      if (!vm.accountsService.currentAccounts || !vm.accountRoles) {
        return [];
      }

      return vm.accountsService.currentAccounts.filter(function(account) {
        if (account.id === vm.accountsService.currentAccountId) {
          return false;
        }

        const role = getAccountRole(account.id);
        if (!role) return false;

        const normalizedRole = role.toLowerCase();

        // Include "user" role in admin section
        if (roleType.toLowerCase() === 'admin') {
          return normalizedRole === 'admin' || normalizedRole === 'user';
        }

        return normalizedRole === roleType.toLowerCase();
      });
    }

    vm.expandedSection = null;

    function toggleRoleSection(section) {
      vm.expandedSection = vm.expandedSection === section ? null : section;
    }

    $scope.$on('$destroy', _onScopeDestroy);

  }
})();
